import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {Operation} from "../common/types/Types";
import {Animated} from "react-animated-css";
import {useHistory} from "react-router-dom";
import {AuthContext} from "../providers/AuthProvider";
import Footer from "../common/views/Footer";
import {BYTable} from "../common/views/BYTable";
import {BYInput} from "../common/inputs/BYInput";
import {CommonHelper} from "../common/CommonHelper";

export const HomeScreen = () => {
    const {operations} = useContext(AuthContext);
    const [filteredOperations, setFilteredOperations] = useState<Operation[]>([]);
    const [searchText, setSearchText] = useState('');
    const history = useHistory();

    useEffect(() => {
        setFilteredOperations(operations);
    }, [operations]);

    useLayoutEffect(() => {
        const filteredOperations = operations.filter((item) => {
            const code = `${item.codeUc}-${item.codeCi}`.toUpperCase();
            const name = item.nomOperation;
            const reference = `${item.refOperation}`.toUpperCase();
            const city = `${item.ville} ${item.cp}`;
            const searchTextUpperCased = searchText.toUpperCase();

            return code.includes(searchTextUpperCased) || CommonHelper.includesWithoutAccents(searchTextUpperCased, name)
                || reference.includes(searchTextUpperCased) || CommonHelper.includesWithoutAccents(searchTextUpperCased, city);
        });

        setFilteredOperations(filteredOperations);
    }, [searchText, operations]);


    return <>
        <Animated className="container page-content" animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
            <h3 className="my-4 color-green">Opérations <small className="color-black">({operations.length})</small></h3>

            <div className="mb-3">
                <BYInput type="text"
                       title="Rechercher"
                       placeholder="Code UC-CI, nom d'opération, ville, code postal, etc."
                       className="form-control"
                       value={searchText}
                       onChange={(e) => setSearchText(e.target.value)}/>
            </div>

            <BYTable
                data={filteredOperations}
                columns={['nomOperation', 'ville', 'cp', 'codeUc']}
                columnNames={['Nom', 'Ville', 'CP', 'UC-CI']}
                dataTransform={{
                    'nomOperation': (operation) => <b>{operation.nomOperation}</b>,
                    'cp': (operation) => <span className="badge bg-success text-light">{operation.cp}</span>,
                    'codeUc': (operation) => `${operation.codeUc}-${operation.codeCi}`,
                }}
                onClick={(operation) => {
                    history.push(`/operation/${operation.refOperation}`);
                }}
                height={60}
                rowsPerPage={15}
            />
        </Animated>

        <Footer/>
    </>;
}
